import NovaSubstrato from "../../../components/Cadastros/Novo/NovoSubstrato";
import Header from "../../../components/Menu";

const NovaSubstratoPage = () => {
  return (
    <div className="flex">
      <Header />
      <NovaSubstrato />
    </div>
  );
};

export default NovaSubstratoPage;
